<div class="gallery-cards">
  <virtual-scroller #scroll [items]="results" class="gallery-cards__content">
    <app-gallery-card
      *ngFor="let item of scroll.viewPortItems"
      [selectLabel]="selectLabel"
      (selectBookmark)="handleSelect($event)"
      [result]="item"
      [columns]="columns"
      [checkable]="checkable"
      [checked]="isChecked(item.id)"
      (checkedChange)="handleCheckedChange($event)"
      [galleryActionsTemplate]="galleryActionsTemplate"
      [galleryTagsTemplate]="galleryTagsTemplate"
      [showActions]="showActions">
    </app-gallery-card>
  </virtual-scroller>
</div>